import React from 'react'
import { Collapse } from 'antd';
import { Link } from "react-router-dom";

const { Panel } = Collapse;
const credit = `
  Enter credit card details here !
`;
const debit = `
  Enter debit card details here !
`;
const netbank = `
  Enter net bank details here !
`;
const wallet = `
  Enter wallet details here !
`;

const paymentMethod = () => {
  const onChange = (key) => {
    console.log(key);
  };

  return (
    <div className='pay-wrap'>
     <div className="rightbar-title">Select Payment Method</div>

     <div className="pay-collapse-wrap">
     <Collapse expandIconPosition="right" defaultActiveKey={['1']} onChange={onChange}>
      <Panel  header="Credit Card" key="1">
      <Link to="/credits">
      <p>{credit}</p>
      </Link>
        
      </Panel>
      <Panel header="Debit Card" key="2">
      <Link to="/adddebitcard">
      <p>{debit}</p>
      </Link>
      </Panel>
      <Panel header="Net Banking" key="3">
      <Link to="/addnetbanking">
      <p>{netbank}</p>
      </Link>
      </Panel>
      <Panel className='wallet-pannel' header="Wallet" key="4">
      <Link to="/addnetbanking">
      <p>{wallet}</p>
      </Link>
      </Panel>
    </Collapse>
     </div>
    </div>
  )
}

export default paymentMethod